// extracted by css-extract-rspack-plugin
export default {"heading1":"Heading1_heading1__Srien"};